import React from 'react'

import { usePageContext } from '~/contexts/page-context'

import * as styles from './styles'

const SmallPrint = () => {
  const { slug } = usePageContext()

  return (
    <div className='us-container'>
      <div className='us-grid-row' sx={styles.smallPrint}>
        <h5 sx={styles.header}>About these results</h5>
        <p>
          {slug === 'fibre_results' ? (
            <small>
              <sup>*</sup>Average speeds are based on the speed available to at least 50% of customers with this product
              during peak time (8 to 10pm). Your actual speeds depend on factors like your connection type, area, time
              of day and distance from the telephone exchange.
            </small>
          ) : (
            <small>
              <sup>*</sup>Average speeds are based on the download speed available to at least 50% of customers with
              this product during peak time (8 to 10pm). Your actual speeds depend on factors like your connection type,
              area, time of day and distance from the telephone exchange.
            </small>
          )}
        </p>
        <p>
          <small>
            Deals are subject to local availability and may not be available to existing customers. You can confirm
            availability and estimated speeds for your property on the provider’s website - this may be different to
            what we show.
          </small>
        </p>
        {slug === 'fibre_results' && (
          <p>
            <small>
              <sup>**</sup>£179 is our calculated savings figure from February 2024, which details the potential amount
              a customer could save per year by choosing a broadband deal on Uswitch.{' '}
              <a href='https://www.uswitch.com/faqs/savings-messages/' target='_blank' rel='noreferrer'>
                Learn how we calculate our savings figures.
              </a>
            </small>
          </p>
        )}
        <p>
          {slug === 'business_broadband' ? (
            <small>
              <sup>§</sup>Order to be completed by 1pm on a working day, for next working day delivery. Selected
              postcodes only. Check the provider site for more details.
            </small>
          ) : (
            <small>
              <sup>§</sup>Order before 8pm for next working day delivery. To find out more about delivery times, please
              check the provider site for more details.
            </small>
          )}
        </p>

        <p>
          <small>
            Some providers may increase monthly costs each year during your contract, in line with the retail or
            consumer price index. Check their terms before signing up.
          </small>
        </p>
        <p>
          <small>
            We’ve highlighted some recent <a href='/telecoms-awards/'>Uswitch Award winners</a> on our table.
          </small>
        </p>
        {slug === 'fibre_results' && (
          <p>
            <small>
              To help customers recognise good customer service, we show TrustPilot scores for providers with a score 4
              or above.
            </small>
          </p>
        )}
        <h5 sx={styles.header}>How our site works</h5>
        <p>
          <small>
            Uswitch services are provided at no cost to you, but we may receive a commission from the companies we refer
            you to. This helps to keep our site free for you to use. Sometimes we have commercial agreements with
            providers to highlight deals that we think are worth your consideration. These deals are labelled
            'sponsored'.
          </small>
        </p>
      </div>
    </div>
  )
}

export default SmallPrint
